import classNames from "classnames";
import React from "react";

import Styles from "./Spinner.module.scss";

type Props = {
  className?: string;
  size?: string;
};

const Spinner = ({ className, size = "" }: Props) => {
  const spinClass = size === "small" ? Styles.smallSize : "";
  return (
    <div role="alert" aria-busy="true" className={classNames(Styles.spinner, className)}>
      <div className={classNames(Styles.spinnerIcon, spinClass)}></div>
    </div>
  );
};

export default Spinner;
